import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export const getAllSeoMissions = (state: RootState) => state.seoMissions;


export const createSeoMissionFullfilledState = createSelector(getAllSeoMissions, (state) => {
    return state.fulfilled;
}
);

export const createSeoMissionLoadingState = createSelector(getAllSeoMissions, (state) => {
    return state.loading["seoMissions/create"];
}
);

export const createSeoMissionErrorState = createSelector(getAllSeoMissions, (state) => {
    return state.error;
}
);

export const seoMissionMessageState = createSelector(getAllSeoMissions, (state) => {
    return state.message;
}
);

export const seoMissionsLoader = createSelector(getAllSeoMissions, (state) => {
    return state.loading
}
);